import { memo, useMemo } from 'react'

import { Grid } from '@mui/material'

import { useLocalStorage } from '@common/utils'

import { METRICS_POSITION_STORAGE_KEY } from './components/MetricsSelector/utils'
import EntityCard from './EntityCard'
import { defaultMetricsPositions } from './utils'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.groupedByEntityData
 * @param {Object} props.selectedMetrics
 * @param {string} props.groupingType
 * @param {boolean} [props.showPercentageChange]
 */
const GroupedByGroupingTypeView = memo(
  ({
    groupedByEntityData,
    selectedMetrics,
    groupingType,
    showPercentageChange = false,
  }) => {
    const [metricsPositions] = useLocalStorage(
      METRICS_POSITION_STORAGE_KEY,
      defaultMetricsPositions,
    )

    const sortFn = (a, b) => {
      const aPosition = metricsPositions[a.metric] ?? 99
      const bPosition = metricsPositions[b.metric] ?? 99
      return aPosition > bPosition ? 1 : -1
    }

    const sortedData = useMemo(
      () => ({
        data: Object.entries(groupedByEntityData.data).reduce(
          (acc, [key, value]) => ({ ...acc, [key]: value.sort(sortFn) }),
          {},
        ),
        summary: groupedByEntityData.summary.sort(sortFn),
      }),
      [groupedByEntityData, metricsPositions],
    )

    const entityCards = Object.entries(sortedData.data).map(([key, item]) => (
      <Grid key={key} size={{ xll: 12, sm: 12 }}>
        <EntityCard
          dataKey={key}
          selectedMetrics={selectedMetrics}
          data={item}
          showPercentageChange={showPercentageChange}
        />
      </Grid>
    ))
    return [
      ...entityCards,
      ...(groupingType === 'property' && entityCards.length === 1
        ? []
        : [
            <Grid key="summary_card" size={{ xll: 12, sm: 12 }}>
              <EntityCard
                dataKey="Total/Average"
                selectedMetrics={selectedMetrics}
                data={sortedData.summary}
                showPercentageChange={showPercentageChange}
              />
            </Grid>,
          ]),
    ]
  },
)

export default GroupedByGroupingTypeView
